export enum RecommendationMode {
	RecommendationNever = 1,
	RecommendationOnDemand = 2,
	RecommendationScheduled = 3,
	RecommendationNotDefined = 4,
}
